function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNewWindowRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 11v2H4v13h18v-3h2v3a2 2 0 01-2 2H4a2 2 0 01-2-2V13a2 2 0 012-2h2zm22-7a2 2 0 012 2v13a2 2 0 01-2 2H10a2 2 0 01-2-2V6a2 2 0 012-2h18zM10 19h18v-9H10v9zm0-11h18V6H10v2z",
    fill: props.color
  }));
}

export default SvgIconNewWindowRexOutline;